import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { MeetingsView } from '@/features/clients/MeetingsView'

type MeetingsSearch = { meeting?: string; email?: string; request?: string }

export const Route = createFileRoute('/clients/$companyId/meetings')({
  validateSearch: (search: Record<string, unknown>): MeetingsSearch => ({
    ...(typeof search.meeting === 'string' && { meeting: search.meeting }),
    ...(typeof search.email === 'string' && { email: search.email }),
    ...(typeof search.request === 'string' && { request: search.request }),
  }),
  component: MeetingsRoute,
})

function MeetingsRoute() {
  const { companyId } = Route.useParams()
  const { meeting, email, request } = Route.useSearch()
  return (
    <AdminGuard>
      <MeetingsView key={email ?? meeting ?? 'latest'} companyId={companyId} initialMeetingId={meeting} initialEmailId={email} highlightRequestId={request} />
    </AdminGuard>
  )
}
